var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("mb-2 bookpage challenge-page current-page challengepage_" + _vm.pageNumber),style:({
        width: '80%'
    }),attrs:{"id":("challengepage_" + _vm.pageNumber)}},[_c('p',{staticClass:"chapter_content",attrs:{"data-cy":"challenge-content-container"},domProps:{"innerHTML":_vm._s(_vm.pageText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }